import { render, staticRenderFns } from "./SalesTable.vue?vue&type=template&id=53ceeaef&scoped=true&"
import script from "./SalesTable.vue?vue&type=script&lang=js&"
export * from "./SalesTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesTable.vue?vue&type=style&index=0&id=53ceeaef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ceeaef",
  null
  
)

export default component.exports